import React, { FC, memo, useContext } from "react";
import { iViewBoxProps } from "./LineChart.helpers";
import { LineChartThemeContext } from "./LineChartTheme.context";

const LineChartAxisX: FC<{
    labels: string[];
    viewport: iViewBoxProps;
    activeTimeIndex: number;
}> = (
    {
        labels,
        viewport,
        activeTimeIndex,
    }
) => {
    const timePointWidth = viewport.width / labels.length;
    const { THEME } = useContext(LineChartThemeContext);

    return (
        <g
            name="axis-x"
            className="LineChart__axis"
            style={{
                transform: `translateY(${viewport.height}px)`,
            }}
        >
            {labels.map((label, index) => {
                const isActive = activeTimeIndex === index;
                return (
                    <React.Fragment key={`${label}-${index}`}>
                        <text
                            key={`${label}-${index}`}
                            x={timePointWidth * (index + 0.5)}
                            y={viewport.padding.bottom / 2}
                            fill={`${isActive ? THEME.TEXT.ACTIVE : THEME.TEXT.DEFAULT}`}
                            textAnchor="middle"
                            alignmentBaseline="middle"
                            fontSize="12px"
                        >
                            {label}
                        </text>
                    </React.Fragment>
                )
            })}
        </g>
    );
};

export default memo(LineChartAxisX);